import Modal from "react-modal";
import { FormattedMessage } from "react-intl";
import { TableManager } from "./admin-table/TableManager";
import { ACTIONS, ENTITIES } from "constants/constants";
import Button from "core/buttons/button/Button";
import PropTypes from "prop-types";

export const HandleModaleBO = ({
  setDeleteData,
  validateDelete,
  deleteData,
  entity,
}) => {
  const customStyles = {
    content: {
      backgroundColor: "#140d49",
      width: "50%",
      margin: "auto",
    },
  };

  let subtitle;

  function afterOpenModal() {
    subtitle.style.color = "#f00";
  }

  function closeModal() {
    setDeleteData(null);
  }

  const modalValidateDelete = (id) => {
    validateDelete(id);
    closeModal();
  };

  const displayDocumentBooleanValues = (values) => {
    return entity === ENTITIES.DOCUMENT
      ? {
          ...values,
          default_document: values.default_document ? "true" : "false",
          status: values.status ? "true" : "false",
        }
      : values;
  };

  return (
    deleteData && (
      <div>
        <Modal
          isOpen={deleteData !== null}
          onAfterOpen={afterOpenModal}
          onRequestClose={closeModal}
          style={customStyles}
        >
          <h2 ref={(_subtitle) => (subtitle = _subtitle)}>
            <FormattedMessage
              id={"admin_ttv_page_modal_header_delete"}
              defaultMessage={"Confirmez-vous la suppression de cet élément?"}
            />
          </h2>
          <div className="modal-table">
            <TableManager
              action={ACTIONS.DETAILS}
              entity={entity}
              entityPerId={displayDocumentBooleanValues(deleteData)}
              formattedEntity={displayDocumentBooleanValues(deleteData)}
              isModal
            />
          </div>
          <br />
          <div className="display-action-button ">
            <Button
              className="btn-hover-color"
              size="small"
              color="blue"
              onClick={closeModal}
            >
              <FormattedMessage id={"cancel"} defaultMessage={"Annuler"} />
            </Button>
            <Button
              className="btn-hover-color"
              size="small"
              color="blue"
              onClick={() => modalValidateDelete(deleteData.id)}
            >
              <FormattedMessage id={"delete"} defaultMessage={"Supprimer"} />
            </Button>
          </div>
        </Modal>
      </div>
    )
  );
};

HandleModaleBO.propTypes = {
  setDeleteData: PropTypes.func,
  validateDelete: PropTypes.func,
  deleteData: PropTypes.object,
};
